/**
 * API配置中心
 * 统一管理所有API接口URL
 */

// 基础API配置
const API_CONFIG = {
  // 基础网关URL
  BASE_URL: process.env.VUE_APP_KSSO_URL || 'https://gateway.keco.vip',
  
  // SSO登录URL
  SSO_URL: process.env.VUE_APP_SSO_URL || 'https://sso.withflows.com',
  
  // API路径配置
  PATHS: {
    // 直播数据相关
    LIVE_SESSION_FULL_SUMMARY: '/api/live/session/full-summary',
    LIVE_ROOM_STATISTICS: '/api/live/room/statistics',
    LIVE_COMMENT_MINUTE_STATISTICS: '/api/live/comment/minute/statistics',
    LIVE_REWARD_LIST: '/api/live/viewers/reward-list',
    LIVE_TOP_GIFTERS: '/api/live/viewers/top',
    LIVE_CONTRIBUTION_STATS: '/api/live/viewers/contribution-stats',
    LIVE_SPENDERS_CONTRIBUTION_STATS_TWO_SEGMENTS: '/api/live/spenders/contribution-stats-two-segments',
    LIVE_COMMENTS: '/api/live/comments',
    LIVE_SESSIONS_ROOM_CURRENT: '/api/live/sessions/room',
    
    // 用户绑定相关
    USER_CREATOR_BINDING_BIND: '/api/user/creator-binding/bind',
    USER_CREATOR_BINDING_STATUS: '/api/user/creator-binding/status',
    USER_CREATOR_BINDING_UNBIND: '/api/user/creator-binding/unbind',
    USER_CREATOR_BINDING_CANCEL: '/api/user/creator-binding/cancel',
    USER_CREATOR_BINDING_LIST: '/api/user/creator-binding/list',
    USER_CREATOR_BINDING_PAGE: '/api/user/creator-binding/page',
    USER_CREATOR_BINDING_DETAIL: '/api/user/creator-binding/detail',
    
    // TikTok账号验证相关
    TIKTOK_CHECK_ACCOUNT: '/api/tiktok/check-account',
    
    // 用户权益相关
    USER_BENEFIT_INFO: '/api/user/benefit/info',
    
    // 认证相关
    KSSO_IS_LOGIN: '/release/ksso/isLogin',
    KSSO_LOGOUT: '/ksso/logout',
    
    // 话术建议相关
    SCRIPT_GENERATION_GENERATE_BY_DESCRIPTION: '/api/script/generation/generate-by-description',
    SCRIPT_GENERATION_GENERATE_BY_COMMENT: '/api/script/generation/generate-by-comment',
    
    // 潜在赞助者相关
    USER_REWARD_PROBABILITY_LIST: '/api/user/reward-probability/list',
    
    // 翻译相关
    UTIP_TRANS_TEXT: '/api/utip/trans/text',
    
    // 用户历史评论列表
    LIVE_COMMENT_LIST: '/api/live/comment/list',

    // 用户会话统计信息
    USER_SESSION_STATS_QUERY: '/api/user/session-stats/query',
    USER_SESSION_STATS_HISTORY: '/api/user/session-stats/history',
    USER_SESSION_STATS_POTENTIAL_SPONSORS: '/api/user/session-stats/potential-sponsors',
    
    // 直播场次列表
    LIVE_SESSION_STATS_LIST: '/api/live/session-stats/list',
    
    // 直播场次详情统计
    LIVE_SESSION_STATS_DETAIL: '/api/live/session-stats/detail',
    
    // 创作者查询接口
    CREATOR_QUERY: '/api/creator/query',
    
    // 聚合查询接口 - 可配置查询多个指标
    LIVE_DATA_ANALYSIS_OVERVIEW: '/api/live/data-analysis/overview',
    
    // 高营收场次接口
    LIVE_DATA_ANALYSIS_TOP_REVENUE_SESSIONS: '/api/live/data-analysis/top-revenue-sessions',
    
    // 场次分析接口 - Prime Time Show板块
    LIVE_SESSION_ANALYSIS: '/api/live/sessions/room',
    
    // 分钟级统计数据接口
    LIVE_SESSION_MINUTE_STATS: '/api/live/session-stats/minute-stats',
    
    // 礼物统计数据接口
    LIVE_SESSION_GIFT_STATS: '/api/live/session-stats/gift-stats',
    
    // 用户参与频次排行接口
    LIVE_SESSION_USER_PARTICIPATION_RANKING: '/api/live/session-stats/user-participation-ranking',
    
    // 礼物类型排行接口（MOST FREQUENT）
    LIVE_SESSION_GIFT_TYPE_RANKING: '/api/live/session-stats/gift-type-ranking',

    // 直播场次总统计数据（Performance Trends - Cumulative）
    LIVE_SESSION_TOTAL_STATS: '/api/live/session-stats/total-stats',
    
    // 直播间AI对话接口
    LIVE_ROOM_AGENT_QUERY: '/api/live-room-agent/query',
    
    // 用户设置接口
    USER_SETTINGS: '/api/user/settings',
    
    // 直播流程详情接口（transcription summary）
    LIVE_SESSION_TRANSCRIPTION_SUMMARY: '/api/live/sessions/room'
  }
};

/**
 * 获取完整的API URL
 * @param {string} pathKey - API路径键名
 * @returns {string} 完整的API URL
 */
export function getApiUrl(pathKey) {
  const path = API_CONFIG.PATHS[pathKey];
  if (!path) {
    throw new Error(`未找到对应的API路径: ${pathKey}`);
  }
  return `${API_CONFIG.BASE_URL}${path}`;
}

/**
 * 获取SSO登录URL
 * @param {string} redirectUrl - 重定向地址
 * @returns {string} 完整的SSO登录URL
 */
export function getSsoLoginUrl(redirectUrl = window.location.href) {
  return `${API_CONFIG.SSO_URL}?redirect=${encodeURIComponent(redirectUrl)}`;
}
